/**
 * Created by rastwe on 1/16/2017.
 * @module $Name$
 * @extends React.Component
 */
import React, {useEffect, useState} from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import {connect} from 'react-redux';
import {labels} from '../../util/uiconstants';
import env from '../../util/env';
import ModalControl from '../Common/Modal/Modal';
import * as VersionUpgradeAction from '../../actions/versionupgradeaction';
import config from '../../../src/auth/config';
import * as TimeoutAction from '../../actions/timeoutactions';
import './index.scss';
import '@ey/motif-react-wrapper/ey-asu-motif.css';
import '@ey/styled-theme/styles.css';
import './main.less';
import MotifInlineMessage from '@ey/motif-react-wrapper/InlineMessage';

createGlobalStyle`
	main {display:block;}
`;

const OfflineContainerwrapper = styled.section`
	box-shadow: 0 0 0 0 #21852e;
	position: absolute;
	font-weight: 700;
	vertical-align: middle;
	text-align: center;
	left: 45%;
	display: flex;
	height: auto;
	padding: var(--px-5);
	background: #009999;
	z-index: 100;
	font-size: var(--px-12);
	border: 0;

	&.training {
		background: var(--purple-400);
	}

	span {
		text-align: center;
		margin: var(--px-3);
		padding: 0;
		font-weight: bold;
		width: auto;
		vertical-align: top;
		line-height: initial;
		color: var(--neutrals-00white);
	}
	svg {
		fill: var(--neutrals-00white);
		margin: var(--px-3) 0;
	}
`;

const PopupContent = styled.section`
	.msg2,
	.msg3 {
		padding-bottom: var(--px-12);
	}
	.msg2 {
		padding-top: var(--spacing-x-large);
	}
	.msg1 {
		border-bottom: var(--px-1) solid var(--neutrals-200);
		padding-bottom: var(--spacing-x-large);
	}
`;

function Main(props) {
	const [showLogoutModal, setShowLogoutModal] = useState(false);
	const [timerMessage, setTimerMessage] = useState(labels.sessionTimerMsg3);
	const [intervalID, setIntervalID] = useState(null);
	const [istraining, setIstraining] = useState(env.getIsTraining());

	const calculateRemainingTime = () => {
		setTimerMessage(
			labels.sessionTimerMsg3.replace('{0}', () => {
				let startTime = props.sessionTimer.logoutTimestamp;
				let endTime = startTime + config.logout_time;
				return Math.round((endTime - Date.now()) / 60000);
			})
		);
	};
	useEffect(() => {
		if (props.sessionTimer.showPopup) {
			setShowLogoutModal(true);
			calculateRemainingTime();
			let _intervalID = setInterval(calculateRemainingTime, 60000);
			setIntervalID(_intervalID);
		} else if (props.sessionTimer.startLogout) {
			props.logoutUserAction();
		}
	}, [props.sessionTimer]);

	useEffect(() => {
		if (props.appVersionState.upgrade) {
			localStorage.setItem('app.version', props.appVersionState.version);
			window.location.reload();
		}
	}, [props.appVersionState.upgrade]);

	const logoutUser = (value) => {
		if (intervalID) {
			clearInterval(intervalID);
			setIntervalID(null);
		}
		props.startLogoutAction();
	};

	var classes = istraining
		? 'main key training mainResponsiveWrappers'
		: 'main key';

	return (
		<React.Fragment>
			<section className={classes}>
				{istraining && (
					<OfflineContainerwrapper className="training">
						<span>{labels.training}</span>
					</OfflineContainerwrapper>
				)}
				{props.children}
			</section>
			<ModalControl
				title={labels.sessionTimerHeader}
				closeTitle={labels.close}
				closeBtnTitle={labels.logout}
				confirmBtnTitle={labels.continue}
				modalContainerClass="logout-modal"
				modalsize="x-small-secondary"
				onOkClick={() => {
					if (intervalID) {
						clearInterval(intervalID);
						setIntervalID(null);
					}
					props.resetIdleTimerAction();
					setShowLogoutModal(false);
				}}
				onHide={logoutUser}
				setModalVisibility={showLogoutModal}
				show={showLogoutModal}
				showButtons
				focusTrapActive={false}
			>
				<PopupContent>
					<section className="msg1 motif-body2-default-light">
						<MotifInlineMessage variant="warning">
							{labels.sessionTimerMsg1}
						</MotifInlineMessage>
					</section>
					<section className="msg2 motif-body1-default-light">
						{labels.sessionTimerMsg2}
					</section>
					<section className="msg3 motif-body1-default-light">
						{timerMessage}
					</section>
					<section className="msg4 motif-body1-default-light">
						<span>{labels.sessionTimerMsg4}</span>
						<span className="msg42 motif-body1-default-bold">
							{' '}
							{labels.continue}
						</span>
					</section>
				</PopupContent>
			</ModalControl>
		</React.Fragment>
	);
}

const mapStateToProps = (storeState) => {
	return {
		appVersionState: storeState.appVersion,
		sessionTimer: storeState.sessionTimer
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		VersionUpgradeAction: (upgrade) => dispatch(VersionUpgradeAction(upgrade)),
		logoutUserAction: () => dispatch(TimeoutAction.logoutUser()),
		startLogoutAction: () => dispatch(TimeoutAction.startLogout()),
		resetIdleTimerAction: () => dispatch(TimeoutAction.resetIdleTimer())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
